<template>
  <div>
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h1 class="text-center">Impressão de Acompanhamento</h1>
      <div v-if="!loadingAcompanhamentos">
        <button @click="print()" class="btn btn-success btn-sm ml-4" v-if="acompanhamentos.length > 0">Imprimir</button>
        <button class="btn btn-default" @click="voltar()">Voltar</button>
      </div>
    </div>
    <load v-if="loadingAcompanhamentos" message="Carregando Acompanhamentos da Família" />
    <div v-else-if="showErrorMessage" class="text-center py-5">
      <div class="alert alert-warning" role="alert">
        <i class="fas fa-exclamation-triangle fa-2x mb-3"></i>
        <h4>{{ errorTitle }}</h4>
        <p>{{ errorMessage }}</p>
        <button class="btn btn-primary mt-2" @click="voltar()">
          <i class="fas fa-arrow-left"></i> Voltar
        </button>
      </div>
    </div>
    <div v-else id="boxPrint" class="col-12 px-0">
      <print-content>
        <table
          v-for="item in acompanhamentos"
          :key="item.id"
          class="table b-table b-table-stacked-xs table-bordered table-sm bg-white"
        >
          <tbody>
            <tr>
              <td colspan="4">
                <h4 class="text-center">Detalhes do Acompanhamento #{{ item.id}}</h4>
              </td>
            </tr>
            <tr>
              <td colspan="4">
                <HeaderAcompanhamento :acompanhamento="item" class="px-0" />
              </td>
            </tr>
            <tr>
              <td colspan="2">
                Serviço:
                <strong>{{
                  verificarValueArray(item.servico_id, servicos)
                }}</strong>
              </td>
              <td colspan="2">
                Técnico de referência:
                <strong>{{
                  verificarValueArray(item.tecnico_id, tecnicos)
                }}</strong>
              </td>
            </tr>
            <tr>
              <td>
                Data de início:
                <strong>{{ item.data_ingresso | formatDate() }}</strong>
              </td>
              <td>
                Data Final:
                <strong>{{ item.data_final | formatDate() }}</strong>
              </td>
              <td>
                Data da Próxima avaliação:
                <strong>{{ item.data_avaliacao | formatDate() }}</strong>
              </td>
              <td>
                Periodicidade:
                <strong>{{
                  verificarValueArray(
                    item.periodicidade,
                    $root.arrays.acompanhamento_periodicidade
                  )
                }}</strong>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                Vulnerabilidades:
                <strong
                  class="badge badge-light mr-2"
                  v-for="(vunerabilidade, i) in item.vulnerabilidades"
                  :key="i"
                  >{{
                    vunerabilidade
                      ? verificarValueArray(vunerabilidade, vulnerabilidades)
                      : ""
                  }}</strong
                >
              </td>
              <td colspan="2">
                Violações de direitos:
                <strong
                  class="badge badge-light mr-2"
                  v-for="(violencia, v) in item.violencias"
                  :key="v"
                >
                  {{
                    violencia
                      ? verificarValueArray(violencia, violencias)
                      : ""
                  }}</strong
                >
              </td>
            </tr>
            <tr class="no-break-inside">
              <td colspan="4">
                Potencialidades:
                <p v-html="item.potencialidades"></p>
              </td>
            </tr>
            <tr class="no-break-inside">
              <td colspan="4">
                Fragilidades:
                <p v-html="item.fragilidades"></p>
              </td>
            </tr>
            <tr class="no-break-inside">
              <td colspan="4">
                Intervenção:
                <p v-html="item.estrategia"></p>
              </td>
            </tr>
            <tr class="no-break-inside">
              <td colspan="4">
                Avaliação Técnica:
                <p v-html="item.diagnostico"></p>
              </td>
            </tr>
            <tr class="no-break-inside">
              <td colspan="4">
                Objetivos a serem atingidos:
                <p v-html="item.recursos_mobilizados"></p>
              </td>
            </tr>
          </tbody>
        </table>
      </print-content>

      <div class="row align-items-center no-print">
        <div class="col-lg-6 col-md-12">
          <div class="form-group d-inline-flex mb-0">
            <select
              class="form-control"
              style="width: 70px"
              v-model="perPage"
              v-on:change="gerarImpressao"
            >
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="30">30</option>
            </select>
          </div>
          <div class="d-inline-flex ml-2">
            <b-pagination
              :per-page="perPage"
              :total-rows="pagination.total"
              @change="changePage"
              v-model="page"
            />
          </div>
        </div>
        <div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
          <div class="float-lg-right">
            {{ $t("Showing page") }}
            {{ pagination.currentPage }}
            de
            {{ pagination.totalPages }}
            {{ $t("pages in") }}
            {{ pagination.total }}
            {{ $t("records") }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderAcompanhamento from './HeaderAcompanhamento.vue';
export default {
  name: 'ImpressaoPAF',
  components: { HeaderAcompanhamento },
  props: {
  },
  data() {
    return {
      showImpressaoAcompanhamentos: false,
      loadingAcompanhamentos: true,
      acompanhamentos: [],
      showErrorMessage: false,
      errorTitle: '',
      errorMessage: '',
      page: 1,
      pagination: {
        currentPage: 0,
        perPage: 0,
        total: 0,
        totalPages: 0,
      },
      perPage: 10,
      vulnerabilidades: [],
      violencias: [],
      tecnicos: [],
      servicos: [],
      unidades: [],
    }
  },
  mounted() {
    this.gerarImpressao();
  },
  methods: {
    gerarImpressao() {
      this.showImpressaoAcompanhamentos = true;
      this.loadingAcompanhamentos = true;
      axios
        .get("api/dashboard/acompanhamentos/impressao", {
          params: {
            id: this.$route.params.id,
            page: this.page,
            perPage: this.perPage,
          },
        })
        .then((response) => {
          this.loadingAcompanhamentos = false;
        
          this.acompanhamentos = response.data.data.data;

          this.pagination = response.data.data.pagination;

          if (this.pagination.totalPages < this.pagination.currentPage) {
            this.page = this.pagination.totalPages;
            this.gerarImpressao();
          }
        })
        .catch((error) => {
          this.loadingAcompanhamentos = false;
          this.showErrorMessage = true;

          if (error.response) {
            switch (error.response.status) {
              case 401:
                this.errorTitle = 'Acesso Negado';
                this.errorMessage = 'Você não tem permissão para visualizar estes acompanhamentos.';
                break;
              case 403:
                this.errorTitle = 'Permissão Insuficiente';
                this.errorMessage = 'Você não possui as permissões necessárias para acessar este recurso.';
                break;
              case 404:
                this.errorTitle = 'Não Encontrado';
                this.errorMessage = 'Os atendimentos solicitados não foram encontrados.';
                break;
              case 500:
                this.errorTitle = 'Erro do Servidor';
                this.errorMessage = 'Ocorreu um erro interno. Tente novamente em alguns instantes.';
                break;
              default:
                this.errorTitle = 'Erro ao Carregar';
                this.errorMessage = error.response.data?.message || 'Não foi possível carregar os acompanhamentos.';
            }
          } else if (error.request) {
            this.errorTitle = 'Erro de Conexão';
            this.errorMessage = 'Não foi possível conectar ao servidor. Verifique sua conexão.';
          } else {
            this.errorTitle = 'Erro Inesperado';
            this.errorMessage = 'Ocorreu um erro inesperado. Tente novamente.';
          }
        });
    },
    voltar() {
      this.showImpressaoAcompanhamentos = false;
      this.$emit('voltar');
    },
    changePage(page) {
      if (
        page > 0 &&
        page <= this.pagination.totalPages &&
        page !== this.page
      ) {
        this.page = page;
        this.gerarImpressao();
      }
    },
    verificarValueArray(value, array) {
      const result = array.filter((item) => item.id == value);
      return result[0] ? result[0].value : "";
    },
    getVulnerabilidades() {
      axios.get(`api/dashboard/get/vulnerabilidades`).then((response) => {
        this.vulnerabilidades = response.data;
      });
    },
    getViolencias() {
      axios.get(`api/dashboard/get/violencias`).then((response) => {
        this.violencias = response.data;
      });
    },
    getServicos() {
      axios.get(`api/dashboard/acompanhamento/servicos`).then((response) => {
        this.servicos = response.data;
      });
    },
    getTecnicos() {
      axios.get(`api/dashboard/tecnicos/get`).then((response) => {
        this.tecnicos = response.data;
      });
    },
    getUnidades() {
      axios
        .get(`api/dashboard/unidades/get/externas/PLANTAO`)
        .then((response) => {
          this.unidades = response.data;
        });
    },
  }
}
</script>